module.exports = __webpack_public_path__ + "img/icon_official2.ed87f1b7.svg";